
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

/**
 * Aramalı, tek-elden yönetilen referans seçici (DEV-2784).
 * Excel Aktar'da hem inline hücrede hem satır düzenleme modalında kullanılır → tasarım
 * bütünlüğü tek yerden gelir. items: {text (gösterim), value (gönderilecek)} dizisi.
 * serbestMetin=true iken listede olmayan değer elle eklenebilir (ör. icra dairesi ozel fallback).
 */
@Component
export default class ReferansSelect extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop({ default: () => [] }) items!: { text: string; value: any }[];
  @Prop({ default: false }) serbestMetin!: boolean;
  @Prop({ default: 'Seçiniz' }) placeholder!: string;
  @Prop({ default: false }) hatali!: boolean;
  @Prop({ default: 100 }) limit!: number;

  acik = false;
  arama = '';
  yukariAc = false;

  // Aktivatörün altında yeterli yer yoksa (ve üstte daha çok yer varsa) menüyü yukarı aç.
  // mousedown'da (menü açılmadan hemen önce) hesaplanır ki :top doğru konumla açılsın.
  konumHesapla(): void {
    const el: any = this.$refs.aktivator;
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    const rect = el.getBoundingClientRect();
    const altBosluk = window.innerHeight - rect.bottom;
    const ustBosluk = rect.top;
    this.yukariAc = altBosluk < 340 && ustBosluk > altBosluk;
  }

  get aramaTemiz(): string {
    return (this.arama || '').trim();
  }

  // Türkçe i ailesi duyarsız normalize (arama karşılaştırması için).
  private norm(s: string): string {
    return String(s || '')
        .replace(/İ/g, 'i').replace(/I/g, 'i').replace(/ı/g, 'i')
        .toLocaleLowerCase('tr-TR')
        .trim();
  }

  get filtrelenmis(): { text: string; value: any }[] {
    const q = this.norm(this.aramaTemiz);
    if (!q) return this.items || [];
    return (this.items || []).filter((it) => this.norm(it.text).includes(q));
  }

  // Performans: büyük listelerde (ör. 1045 icra dairesi) yalnız ilk limit kadar render edilir.
  get gorunenler(): { text: string; value: any }[] {
    return this.filtrelenmis.slice(0, this.limit);
  }

  get kalan(): number {
    return Math.max(0, this.filtrelenmis.length - this.limit);
  }

  get tamEslesme(): boolean {
    const q = this.norm(this.aramaTemiz);
    return (this.items || []).some((it) => this.norm(it.text) === q);
  }

  // Seçili value'nun görüntülenecek metni; serbest metinde value listede yoksa kendisini gösterir.
  get gosterim(): string {
    if (this.value === null || this.value === undefined || this.value === '') return '';
    const bul = (this.items || []).find((it) => String(it.value) === String(this.value));
    return bul ? bul.text : String(this.value);
  }

  @Watch('acik')
  onAcikChange(v: boolean) {
    if (v) {
      this.arama = '';
      this.$emit('acildi');
      this.$nextTick(() => {
        const inp: any = this.$refs.aramaInput;
        if (inp && typeof inp.focus === 'function') inp.focus();
      });
    } else {
      this.$emit('kapandi');
    }
  }

  sec(item: { text: string; value: any }) {
    this.$emit('input', item.value);
    this.acik = false;
  }

  serbestSec() {
    this.$emit('input', this.aramaTemiz);
    this.acik = false;
  }
}
